enum LoadingAreaEnum {
  PAGE = "PAGE",
  EXCHANGE = "EXCHANGE",
  BOOKMAKER = "BOOKMAKER",
  FANCYBET = "FANCYBET",
  MINI_GAME = "MINI_GAME",
  SPORTSBOOK = "SPORTSBOOK",
  GENIUSSPORTS = "GENIUSSPORTS",
  WALLET = "WALLET",
  OPEN_BET = "OPEN_BET",
  REPORT = "REPORT"
}

export type LoadingArea = keyof typeof LoadingAreaEnum

export const useLoadingStore = defineStore("loading", () => {
  const mapCount = ref(
    new Map<LoadingArea, number>(Object.values(LoadingAreaEnum).map(area => [area, 0]))
  )

  const reset = (target: LoadingArea) => {
    mapCount.value.set(target, 0)
  }

  const accumulate = (target: LoadingArea, value: number) => {
    mapCount.value.set(target, (mapCount.value.get(target) || 0) + value)
  }

  const load = (target: LoadingArea) => accumulate(target, 1)
  const unload = (target: LoadingArea) => accumulate(target, -1)

  return {
    mapCount,
    load,
    unload,
    reset
  }
})

export default useLoadingStore
